const adultContentElements = document.querySelectorAll('.crash-content');

adultContentElements.forEach((itm) => {
  const adultContentDiv = document.createElement('div');
  const adultContentDivWrapper = document.createElement('div');
  adultContentDiv.classList.add('adult-content'); // Add a descriptive class
  adultContentDiv.append(adultContentDivWrapper);
  adultContentDivWrapper.className = 'adult-content__wrapper';

  const handleYes = () => {
    adultContentDiv.children[0].remove();
    adultContentDiv.className = '';
  }

  const handleNo = () => {
    adultContentDiv.children[0].innerHTML = '';
  }

  // Set title and subtitle:
  adultContentDivWrapper.innerHTML = `
<svg width="54" height="51" viewBox="0 0 54 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2613_35937)">
<path d="M35.1 39.195C32.89 40.985 30.07 42.065 27 42.065C19.91 42.065 14.16 36.315 14.16 29.215C14.16 26.155 15.24 23.335 17.03 21.125L35.1 39.195Z" fill="#F7F7F7"/>
<path d="M39.85 29.215C39.85 32.165 38.86 34.875 37.19 37.045L19.18 19.035C21.35 17.365 24.05 16.375 27 16.375C27.7 16.375 28.38 16.445 29.05 16.555C27.58 17.955 26.66 19.925 26.66 22.105C26.66 26.345 30.09 29.775 34.33 29.775C36.44 29.775 38.34 28.925 39.73 27.555C39.8 28.105 39.85 28.655 39.85 29.215Z" fill="#F7F7F7"/>
<path d="M1.64001 1.2749L50.09 49.7249" stroke="#F7F7F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.57001 14.4348C5.94001 17.4248 3.10001 21.3348 1.39001 25.8048" stroke="#F7F7F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M52.61 25.7948C48.67 15.4948 38.69 8.1748 27 8.1748C21.8 8.1748 16.94 9.6248 12.8 12.1348" stroke="#F7F7F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2613_35937">
<rect width="53.22" height="50.45" fill="white" transform="translate(0.390015 0.274902)"/>
</clipPath>
</defs>
</svg>
<p class="adult-content__title">Контент 18+</p>
<p class="adult-content__subtitle">${window.locale === 'ru' ? 'Вам уже исполнилось 18 лет?' : 'Вам вже є 18 років?'}</p>
`;

  // Add buttons (customize as needed):
  adultContentDivWrapper.innerHTML += `
<div class="adult-content__btnWrapper">
  <button class="adult-content__btn adult-content__btn_yes">${window.locale === 'ru' ? 'Да' : 'Так'}</button>
  <button class="adult-content__btn adult-content__btn_no">${window.locale === 'ru' ? 'Нет' : 'Ні'}</button>
</div>
`;

  adultContentDivWrapper.querySelector('.adult-content__btn_yes').addEventListener('click', handleYes);
  adultContentDivWrapper.querySelector('.adult-content__btn_no').addEventListener('click', handleNo);

  itm.parentNode.prepend(adultContentDiv);
  adultContentDiv.append(itm)

})